// Central business details — edit here and the whole site updates.
export const BOOKING_URL = "https://www.caljn.com/business/no1-nails";
export const PHONE = "(02) 9977 8488";
export const PHONE_HREF = "tel:+61299778488";
export const MOBILE = "+61 (0) 449 908 779";
export const MOBILE_HREF = "tel:+61449908779";
export const EMAIL = "thilinhnguyen72@gmail.com";
export const EMAIL_HREF = "mailto:thilinhnguyen72@gmail.com";
export const ADDRESS = "5A Market Lane, Manly NSW 2095";
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=5A+Market+Lane%2C+Manly+NSW+2095";
export const INSTAGRAM_URL = "https://www.instagram.com/numberonenailsmanly/";
export const WEBSITE_URL = "https://numberonenailsmanly.com/";
export const WEBSITE_LABEL = "numberonenailsmanly.com";

export const HOURS = [
  ["Mon", "9:00 – 6:00", false],
  ["Tue", "9:00 – 6:00", false],
  ["Wed", "9:00 – 6:00", false],
  ["Thu", "9:00 – 7:30", true],
  ["Fri", "9:00 – 6:00", false],
  ["Sat", "8:30 – 5:30", false],
  ["Sun", "9:30 – 5:00", false],
];

export const SERVICES = [
  {
    t: "Gel manicure",
    d: "Long-lasting colour, chip-free and gentle on natural nails.",
  },
  {
    t: "Acrylic nails",
    d: "Sculpted extensions in any shape, applied with precision.",
  },
  {
    t: "Classic manicure",
    d: "Shaping, cuticle care, and a flawless polish finish.",
  },
  {
    t: "Spa pedicure",
    d: "Soak, exfoliate, massage, and perfect colour — pure relaxation.",
  },
  {
    t: "Classic pedicure",
    d: "Essential foot care and colour, beautifully finished.",
  },
];
